import { useEffect } from 'react';

/**
 * @example
 * useAddNativeClasses(true, 'ios');
 *
 * @example
 * <span className="group-[.is-native]:hidden">This is hidden on native.</span>
 */

export default function useAddNativeClasses(
  isNative: boolean,
  platform: 'android' | 'ios' | null
) {
  useEffect(() => {
    if (isNative) {
      document.documentElement.classList.add('group', 'is-native');
    }
    if (platform) {
      document.documentElement.classList.add(`is-native-${platform}`);
    }
  }, [isNative, platform]);
}
